import { SwitchInput, TextInput } from "components/core";
import { DistrictPicker } from "containers";
import { useFormik } from "formik";
import { FC } from "react";
import { CreatePremiumServiceInterestInterestInfoSchema } from "./schema";
import { wrapClick } from "utils";


export interface CreatePremiumServiceInterestFormProps {
  handleNext: (values: any) => void;
  handlePrevious: () => void;
  initialValues: any;
  values: any;
  handleCancel: () => void;
}

export const CreatePremiumServiceInterestForm: FC<
CreatePremiumServiceInterestFormProps
> = ({ initialValues, handleNext, handleCancel }) => {

  const form = useFormik({
    initialValues,
    validationSchema: CreatePremiumServiceInterestInterestInfoSchema,
    onSubmit: (values) => {
      handleNext(values);
    },
    onReset: () => {
      handleCancel?.();
    },
  });

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="space-y-6 divide-y divide-gray-200 p-6 flex-1 overflow-y-auto">
        <div>
          <span className="text-xs font-light">Location</span>
          <div className="grid grid-cols-1 gap-6 mt-2">
            <DistrictPicker
              id="district"
              {...form}
              label="District (if available)"
              rawId
            />
          </div>
        </div>
        <div className="pt-2">
          <span className="text-xs font-light">Customer Details</span>
          <div className="grid grid-cols-2 gap-6 mt-2">
            <div>
              <TextInput
                id="customer.fullName"
                label="Full Name"
                type="text"
                placeholder="e.g. Solomon Nana Kweku Bekoe"
                required
                {...form}
              />
            </div>
            <div>
              <TextInput
                id="customer.phoneNumber"
                label="Phone Number"
                type="text"
                placeholder="e.g. 0244123456"
                required
                {...form}
              />
            </div>
            <div className="">
              <TextInput
                id="customer.digitalAddress"
                label="Digital Address"
                type="text"
                placeholder="e.g. AE-0223-1090"
                required
                {...form}
              />
            </div>
            <div className="">
              <SwitchInput
                id="generateRAT"
                label="Generate Readiness Acceptance"
                description="Automatically generate a Readiness Acceptance Test for the customer"
                required
                {...form}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:py-4 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200">
        <button
          type="button"
          onClick={wrapClick(form.handleSubmit)}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Next
        </button>
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(form.resetForm)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CreatePremiumServiceInterestForm;
